export const getChangeOrderStatus = item => {
    return (item.status === 'draft' || !item.status) && !!item.sent_at ? 'sent' : (!item.status ? 'draft' : item.status)
}
